import { Injectable, Provider } from "@angular/core";
import { MatomoConfiguration, MatomoTracker, MATOMO_CONFIGURATION } from "ngx-matomo-client";
import { BehaviorSubject } from "rxjs";

// TODO 14420 - Matomo - implement new Matomo tracking package
//import { MatomoConfiguration } from "@ngx-matomo/tracker";

export interface MatomoConfigType {
    siteId: number;
    trackerUrl: string;
    mode: "auto" | "manual" | "deferred";
}

const initialConfig: MatomoConfigType = {
    siteId: 2334,
    trackerUrl: "https://matomo.eforsyning.dk",
    mode: "auto"
};

@Injectable({
    providedIn: "root"
})
export class MatomoConfigService {
    private currentConfig = new BehaviorSubject<MatomoConfigType>(initialConfig);

    constructor(private matomoTracker: MatomoTracker) {
        // Initialize tracking with default configuration
        this.initializeTracking(initialConfig);
    }

    private initializeTracking(config: MatomoConfigType): void {
        //this.matomoTracker.setTrackerUrl(config.trackerUrl);
        this.matomoTracker.setSiteId(config.siteId.toString());
        this.matomoTracker.enableLinkTracking(true);
        this.matomoTracker.enableHeartBeatTimer(15);
    }

    public updateSiteId(siteId: number): void {
        const newConfig = {
            ...this.currentConfig.value,
            siteId
        };
        this.currentConfig.next(newConfig);
        this.initializeTracking(newConfig);
    }

    public getCurrentConfig(): MatomoConfigType {
        return this.currentConfig.value;
    }

    public buildConfig(matomoSiteId: number): MatomoConfigType {
        const config = {
            ...initialConfig,
            siteId: matomoSiteId
        };
        this.currentConfig.next(config);
        this.initializeTracking(config);
        return config;
    }
}

export const matomoProvider: Provider = {
    provide: MATOMO_CONFIGURATION,
    useValue: initialConfig
};
